<template lang="pug">
  .container.grid-xl
    page-title(
      title="Relatórios em CSV"
      icon="fas fa-file-csv"
      subtitle="Relatórios retornados em csv"
    )
    .columns.mb-2
      .column.col-8.col-sm-12
        .toast.toast-warning
          h6 Atenção
          p Estes relatórios utilizam muito processamento, evite executá-los durante horários de pico
    .columns
      .column.col-4.col-md-6.col-sm-12.my-2
        active-subscribers
      .column.col-4.col-md-6.col-sm-12.my-2
        people
</template>

<script>
import ActiveSubscribers from './components/ActiveSubscribers.vue'
import People from './components/People.vue'

export default {
  components: { ActiveSubscribers, People },
}
</script>
